export { default as initializeMailFavicon } from './utils/initializeMailFavicon';
//# sourceMappingURL=index.js.map